import { render, staticRenderFns } from "./ModalListMkProducts.vue?vue&type=template&id=6a84f96f&scoped=true"
import script from "./ModalListMkProducts.vue?vue&type=script&lang=js"
export * from "./ModalListMkProducts.vue?vue&type=script&lang=js"
import style0 from "./ModalListMkProducts.vue?vue&type=style&index=0&id=6a84f96f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a84f96f",
  null
  
)

export default component.exports